import React from "react";
import { Actionable, SheetContainer } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller";
import { type UnifiedPriceTagPriceBreakdownProps } from "./UnifiedPriceTagPriceBreakdown";

export const UnifiedPriceTagPriceBreakdownMobile = ({
  priceBreakdownTrigger,
  priceBreakdownTriggerProps,
  priceBreakdownContent,
  priceBreakdownOnOpen = () => {},
  priceBreakdownOnClose = () => {}
}: UnifiedPriceTagPriceBreakdownProps) => {
  const { contentTitle, closeAriaLabel, showPriceBreakdown, setShowPriceBreakdown } =
    useUnifiedPriceTagPriceBreakdownController();

  if (!priceBreakdownTrigger || !priceBreakdownContent) {
    return;
  }

  return (
    <>
      <Actionable
        onClick={(e) => {
          e.stopPropagation();
          if (!showPriceBreakdown) {
            setShowPriceBreakdown(true);
            priceBreakdownOnOpen();
          }
        }}
        {...priceBreakdownTriggerProps}
      >
        {priceBreakdownTrigger}
      </Actionable>
      {showPriceBreakdown && (
        <SheetContainer
          onCloseTrigger={() => {
            setShowPriceBreakdown(false);
            priceBreakdownOnClose();
          }}
          title={contentTitle}
          closeAriaLabel={closeAriaLabel}
          active={true}
          attributes={{
            "data-testid": "upt_price_breakdown_content"
          }}
        >
          {priceBreakdownContent}
        </SheetContainer>
      )}
    </>
  );
};
